import { api } from "@/services/api/createAPI";
import { getAuthToken } from "@/services/supabase/auth/actions/getAuthToken";
import { v2 } from "@pufflig/prompt-studio-types";

export const runSQl = async (sql: string, connectorId: string): Promise<v2.TableResult> => {
  const token = await getAuthToken();
  const { data: result } = await api(token).post("/api/sql/run", {
    sql,
    connectorId,
  });

  const { data, error } = result;

  if (error) {
    throw new Error(error);
  }

  return data;
};
